import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlContainer, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { HlmButtonDirective } from '@spartan-ng/ui-button-helm';
import { NgSelectModule } from '@ng-select/ng-select';
import { LucideAngularModule } from 'lucide-angular';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-select',
  imports: [CommonModule, HlmButtonDirective, NgSelectModule, LucideAngularModule, ReactiveFormsModule],
  templateUrl: './select.component.html',
  standalone: true,
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: () => inject(ControlContainer, { skipSelf: true }),
    },
  ],
})
export class SelectComponent implements OnInit, OnDestroy {
  @Output() onChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSearch: EventEmitter<{
    term: string;
    items: any[];
  }> = new EventEmitter<any>();

  @Input({ required: true }) options: any[];
  @Input({ required: true }) control = '';
  @Input() searchable: boolean = true;
  @Input() multiple: boolean;
  @Input() readOnly: boolean;
  @Input() required: boolean;
  @Input() loading: boolean;
  @Input() placeholder: string;
  @Input() clearable: boolean = false;
  @Input() className: string = '';
  @Input() label = '';

  parentContainer = inject(ControlContainer);
  errorMessages: Record<string, string>;

  get parentFormGroup() {
    return this.parentContainer.control as FormGroup;
  }

  ngOnInit() {
    this.parentFormGroup.addControl(this.control, new FormControl(null));
    this.setErrorMessages();
  }

  get formControl() {
    return this.parentFormGroup.get(this.control) as FormControl;
  }

  setErrorMessages() {
    this.errorMessages = {
      required: 'This field is required',
    };
  }

  public onSelectAll() {
    const selected = this.options.map(item => item.value);
    this.formControl.patchValue(selected);
  }

  public clearAll() {
    this.formControl.patchValue([]);
  }

  displayErrors() {
    const { invalid, dirty, touched } = this.parentFormGroup.get(this.control) as FormControl;
    return invalid && (dirty || touched);
  }

  ngOnDestroy() {
    this.parentFormGroup.removeControl(this.control);
  }
}
